import { useDispatch, useSelector } from 'react-redux'
import {
    setData,
    setLoading,
    TeacherDataKey,
} from '../../../../redux/teacherSlice'
import { useEffect } from 'react'
import { onValue, ref, Unsubscribe } from 'firebase/database'
import { db } from '../../../../firebase/configs'
import { selectUserUid } from '../../../../redux/userSlice'

const useTeacherDataListener = (keyName: TeacherDataKey, dbPath?: string) => {
    const userId = useSelector(selectUserUid)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!userId) return

        dispatch(setLoading(keyName))

        const unsub: Unsubscribe = onValue(
            ref(db, `teachers/${userId}/${dbPath || keyName}`),
            (snap) => {
                if (snap.exists()) {
                    dispatch(setData({ key: keyName, value: snap.val() }))
                } else {
                    dispatch(setData({ key: keyName, value: null }))
                }
            }
        )

        // Cleanup
        return () => {
            unsub()
            dispatch(setData({ key: keyName, value: undefined }))
        }
    }, [userId, dispatch, keyName, dbPath])

    return null
}

export default useTeacherDataListener
